import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=1e675278&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=1e675278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e675278",
  null
  
)

export default component.exports